import Vue from "vue";
import App from "./App.vue";
import "./assets/css/main.css";
import ElementUI from "element-ui";
import zhCN from 'element-ui/lib/locale/lang/zh-CN';
import zhTW from 'element-ui/lib/locale/lang/zh-TW';
import en from 'element-ui/lib/locale/lang/en';
import router from "./router";
import "./assets/theme/index.css"; // 自定义主题
import { Message } from "element-ui";
import store from "@/store";
import "@/assets/js/iconfont.js";
import QuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.bubble.css";
import "quill/dist/quill.snow.css";
import { pcLoginCallBack } from "./api/login";
import echarts from "echarts";
import vuex from "@/store/index";
import { queryEmpRouter } from "./api/companyManage";
import { getDataTimeSec } from "@/utils/index";
import userRoot from '@/utils/root'
import { i18nManager } from "@/utils/i18n";
import backendMessages from "@/utils/i18n/i18n-messages.json";

Vue.use(QuillEditor);
Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false;
// 配置Element UI的多语言
const currentLanguage = localStorage.getItem('language') || 'zh-TW';

// 获取Element UI的完整国际化配置
function getElementUILocale() {
  const localeMap = {
    'zh-CN': zhCN,
    'zh-TW': zhTW,
    'en': en
  };
  return localeMap[currentLanguage] || zhTW;
}


// 配置Element UI的完整国际化
const elementLocale = getElementUILocale();
Vue.use(ElementUI, {
  size: "small",
  locale: elementLocale
});

Vue.prototype.$message = Message;
Vue.prototype.$i18n = i18nManager;

// 确保语言设置正确初始化
const savedLanguage = localStorage.getItem('language') || 'zh-TW';
if (savedLanguage !== i18nManager.getCurrentLanguage()) {
  i18nManager.setLanguage(savedLanguage);
}
store.commit('SET_LANGUAGE', savedLanguage);

// 添加全局方法用于更新Element UI的locale
Vue.prototype.$updateElementUILocale = function(language) {
  const localeMap = {
    'zh-CN': zhCN,
    'zh-TW': zhTW,
    'en': en
  };
  const newLocale = localeMap[language] || zhTW;
  
  // 更新Element UI的locale配置
  if (this.$ELEMENT && this.$ELEMENT.locale) {
    this.$ELEMENT.locale = newLocale;
  }
  
  // 触发全局事件
  this.$root.$emit('element-ui-locale-updated');
};

const defaultRouters = userRoot.defaultRouters
Vue.prototype.$defaultRouters = defaultRouters;

router.beforeEach((to, form, next) => {
  // 设置页面标题的多语言支持
  if (to.meta && to.meta.title) {
    const title = to.meta.title;
    // 如果title是多语言对象
    if (typeof title === 'object' && title !== null) {
      const currentLanguage = store.state.currentLanguage || 'zh-TW';
      document.title = title[currentLanguage] || title['zh-TW'] || '睿哲智能crm';
    } else {
      // 如果title是字符串，直接使用
      document.title = title;
    }
  } else {
    // 如果没有标题，使用默认标题
    document.title = '睿哲智能crm';
  }
  
  //login登录授权回调
  if (to.query.code) {
    //保存code 回调成功后 删除
    localStorage.setItem("code", to.query.code);
    let date = new Date();
    date = getDataTimeSec(date);
    //请求扫码回调验证 验证通过保存token
    pcLoginCallBack({
      code: to.query.code,
      state: to.query.state,
      appid: to.query.appid,
    })
      .then((res) => {
        console.log("扫码回调:", res);
        //存储登录用户信息
        localStorage.setItem("info", JSON.stringify(res.data));
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("loginDate", res.data.lastLoginTime);
        localStorage.setItem("codePhoen", res.data.phone);
        store.state.loginRoot.loginDate = res.data.lastLoginTime;
        store.state.loginRoot.userInfo = res.data;
        localStorage.removeItem("code");
        router.push("/dashboard");
      })
      .catch((error) => {
        localStorage.removeItem("code");
        Message({ message: error ? error.message : error, type: "error" });
        router.push("/login");
      });
  } else if (to.query.auth_code) {
    //授权回调下放到vue业务页面处理
    next();
  } else {
    if (!localStorage.getItem("code")) {
      if (to.path !== "/login") {
        if (!localStorage.getItem("token")) {
          router.push("/login");
        }
      }
      next();
    }
  }
  let userInfo = JSON.parse(localStorage.getItem("info"));
  if (userInfo && !userInfo.roleId) {
    queryEmpRouter({}).then((res) => {
      let routers = defaultRouters
      if (res.data) {
        if (res.data.routerId && typeof res.data.routerId === 'string') {
          try {
            // 将单引号替换为双引号，然后解析
            const routerIdStr = res.data.routerId.replace(/'/g, '"');
            res.data.routerId = JSON.parse(routerIdStr);
          } catch (error) {
            console.error('解析routerId失败:', error, res.data.routerId);
            res.data.routerId = null;
          }
        }
        
        if (res.data.routerId && Array.isArray(res.data.routerId)) {
          routers = res.data.routerId
        }
        if (res.data.empId) {
          vuex.commit("setEmpId", res.data.empId);
        }
      }
      console.log('routers', routers)
      vuex.commit("setRouterArr", routers);
    });
  }
});


// 处理消息的多语言查找
function getLocalizedBackMessage(message) {
  // 如果message不是字符串，直接返回
  if (typeof message !== 'string') {
    return message;
  }
  
  // 动态获取当前语言
  const currentLang = localStorage.getItem('language') || 'zh-TW';
  
  // 如果前端i18n没有找到，查找后端错误码
  const backendLang = currentLang === 'zh-CN' ? 'zh_CN' : currentLang === 'zh-TW' ? 'zh_TW' : 'en';
  const backendLangConfig = backendMessages[backendLang] || backendMessages['zh_CN'];
  
  if (backendLangConfig && backendLangConfig[message]) {
    return backendLangConfig[message];
  }
  
  // 如果都没有找到，返回原message
  return message;
}

// 重写 $message 方法，支持多语言
const originalMessage = Vue.prototype.$message;
Vue.prototype.$message = function(options) {
  if (typeof options === 'string') {
    // 如果传入的是字符串，转换为对象格式
    options = {
      message: options,
      type: 'info'
    };
  }
  
  // 处理消息的多语言
  if (options.message) {
    options.message = getLocalizedBackMessage(options.message);
  }
  
  // 调用原始的 $message 方法
  return originalMessage.call(this, options);
};

// 保留 Element UI 的便捷方法
Vue.prototype.$message.success = function(message) {
  return originalMessage.call(this, {
    message: getLocalizedBackMessage(message),
    type: 'success'
  });
};

Vue.prototype.$message.warning = function(message) {
  return originalMessage.call(this, {
    message: getLocalizedBackMessage(message),
    type: 'warning'
  });
};

Vue.prototype.$message.info = function(message) {
  return originalMessage.call(this, {
    message: getLocalizedBackMessage(message),
    type: 'info'
  });
};

Vue.prototype.$message.error = function(message) {
  return originalMessage.call(this, {
    message: getLocalizedBackMessage(message),
    type: 'error'
  });
};

Vue.prototype.$message.msg = function(message) {
  return originalMessage.call(this, {
    message: getLocalizedBackMessage(message),
    type: 'info'
  });
};


Vue.prototype.$message.closeAll = function() {
  originalMessage.closeAll();
};


new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
